class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.flyoutSubDetails = this.querySelectorAll('.flyout-menu__item--has-children > details');

    this.mainDetailsToggle.addEventListener('mouseenter', this.openMenuOnHover.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.closeMenuOnHover.bind(this));

    this.flyoutSubDetails.forEach((detailsElement) => {
      detailsElement.addEventListener('mouseenter', this.openFlyoutSubmenuOnHover.bind(this));
      detailsElement.addEventListener('mouseleave', this.closeFlyoutSubmenuOnHover.bind(this));
      detailsElement.addEventListener('toggle', this.onFlyoutSubToggle.bind(this));
    });
  }

  openMenuOnHover() {
    if (!this.mainDetailsToggle.open) {
      this.mainDetailsToggle.setAttribute('open', true);
      this.mainDetailsToggle.querySelector('summary')?.setAttribute('aria-expanded', true);
      if (this.header) this.header.preventHide = true;
    }
  }

  closeMenuOnHover(event) {
    if (event.relatedTarget && this.mainDetailsToggle.contains(event.relatedTarget)) return;

    this.close();
    this.closeFlyoutSubmenus();
  }

  openFlyoutSubmenuOnHover(event) {
    const detailsElement = event.currentTarget;

    if (!detailsElement.open) {
      detailsElement.setAttribute('open', true);
      detailsElement.querySelector('summary')?.setAttribute('aria-expanded', true);
    }
  }

  closeFlyoutSubmenuOnHover(event) {
    const detailsElement = event.currentTarget;

    if (event.relatedTarget && detailsElement.contains(event.relatedTarget)) return;

    detailsElement.removeAttribute('open');
    const summary = detailsElement.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', false);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (!this.mainDetailsToggle.open) this.closeFlyoutSubmenus();

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  onFlyoutSubToggle(event) {
    const toggledDetails = event.currentTarget;
    if (!toggledDetails?.open) return;

    const level2Menu = toggledDetails.closest('.flyout-menu--level-2');
    if (!level2Menu) return;

    level2Menu.querySelectorAll('.flyout-menu__item--has-children > details[open]').forEach((detailsElement) => {
      if (detailsElement === toggledDetails) return;
      detailsElement.removeAttribute('open');
      const summary = detailsElement.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', false);
    });
  }

  closeFlyoutSubmenus() {
    this.flyoutSubDetails.forEach((detailsElement) => {
      detailsElement.removeAttribute('open');
      const summary = detailsElement.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', false);
    });
  }
}

customElements.define('header-menu', HeaderMenu);
